import moment from 'moment';

export default function getDateWithAnneeSemaineAndJourDepart(anneeSemaine, jourDepart) {
  if (anneeSemaine === '') return '';
  const date = moment(anneeSemaine, 'GGGGWW')
    .startOf('isoWeek')
    .add((jourDepart + 6) % 7, 'd');
  return date;
}
